import TextField from "@mui/material/TextField";
import {InputAdornment} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IndonesiaFlag from "../IndonesiaFlag";
import {useTranslation} from "react-i18next";

const TextInput = ({field, value, onChange, error, helperText, disabled}) => {
    const { t } = useTranslation();

    const isPhoneNumber = field?.validation?.[0] === "phoneNumber";

    if (isPhoneNumber) {
        return (
            <TextField
                type="tel"
                onChange={(e) => {
                    let d = e.target.value.replace(/\D/g, "");

                    // Normalize common Indonesia cases:
                    if (d.startsWith("62")) d = d.slice(2);
                    d = d.replace(/^0+/, "");

                    if (d !== "" && !d.startsWith("8")) d = "8" + d;

                    onChange(field.id, d);
                }}
                value={value ?? ""}
                error={error}
                helperText={t('phoneNumber.helpertext') || "Please enter your WhatsApp number"}
                variant="outlined"
                fullWidth
                disabled={(field.allowEdit === false && !!value) || disabled}
                InputProps={{
                    startAdornment: (
                        <InputAdornment
                            position="start"
                            sx={{
                                alignItems: "center",
                                ".MuiTypography-root": { fontSize: "1rem", lineHeight: 1 },
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <IndonesiaFlag />
                                <Typography component="span">+62</Typography>
                            </Box>
                        </InputAdornment>
                    ),
                }}
                inputProps={{
                    inputMode: "numeric",
                    sx: { fontSize: "1rem", lineHeight: 1 }, // match adornment
                }}
            />
        );
    }

    // Default text field
    return (
        <TextField
            onChange={(e) => onChange(field.id, e.target.value)}
            value={value}
            error={error}
            helperText={helperText}
            variant="outlined"
            fullWidth
            multiline
            disabled={(field.allowEdit === false && !!value) || disabled}
        />
    );
};

export default TextInput;
